import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SectionHeading } from "@/components/SectionHeading";
import { useLang } from "@/context/LanguageContext";

// Shared chrome for inner pages (/blog, /blog/:slug, /admin): header + footer + heading block.
export const PageShell = ({ eyebrow, title, titleItalic, description, children, testId, narrow = false }) => {
  const { lang } = useLang();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="grain bg-ink font-body text-cream" lang={lang === "te" ? "te" : "en"} data-testid={testId}>
      <Header />
      <main className={`mx-auto px-5 pb-24 pt-32 md:px-8 md:pb-32 md:pt-40 ${narrow ? "max-w-3xl" : "max-w-7xl"}`}>
        {title && (
          <div className="mb-12 md:mb-16">
            <SectionHeading eyebrow={eyebrow} title={title} titleItalic={titleItalic} description={description} />
          </div>
        )}
        {children}
      </main>
      <Footer />
    </div>
  );
};
